"use strict";
exports.__esModule = true;
exports.hmsToSeconds = exports.isLessonComplete = exports.percentComplete = exports.convertTimeWithTitles = exports.convertTime = exports.convertTimeToMins = void 0;
var lodash_1 = require("lodash");
/* eslint-disable */
function pad(s) {
    return s.length > 10 ? s : s.length == 0 ? '00' : s;
}
function convertTimeToMins(seconds) {
    if (seconds < 0)
        seconds = 0;
    var mins = ~~(seconds / 60);
    return "".concat(pad(mins.toString()), "m");
}
exports.convertTimeToMins = convertTimeToMins;
function convertTime(seconds) {
    if (seconds < 0)
        seconds = 0;
    var hours = ~~(seconds / 3600);
    var mins = ~~((seconds - hours * 3600) / 60);
    var secs = (seconds - hours * 3600 - mins * 60) % 60;
    return [hours, mins, secs]
        .filter(function (i, index) { return i > 0 || index > 0; })
        .map(function (i) { return i.toString().padStart(2, '0'); })
        .join(':');
}
exports.convertTime = convertTime;
function convertTimeWithTitles(seconds, options) {
    if (options === void 0) { options = {}; }
    if (seconds < 0)
        seconds = 0;
    var hours = ~~(seconds / 3600);
    var mins = ~~((seconds - hours * 3600) / 60);
    var secs = (seconds - hours * 3600 - mins * 60) % 60;
    var showSeconds = (0, lodash_1.get)(options, 'showSeconds', false);
    var result = '';
    var longForm = (0, lodash_1.get)(options, 'longForm', false);
    var hoursAppend = longForm ? ' hours ' : 'h ';
    var minsAppend = longForm ? ' minutes ' : 'm ';
    var secondsAppend = longForm ? ' seconds' : 's';
    if (hours)
        result += hours + hoursAppend;
    if (mins)
        result += mins + minsAppend;
    if (secs && !hours && showSeconds)
        result += secs.toFixed(0) + secondsAppend;
    return result.trim();
}
exports.convertTimeWithTitles = convertTimeWithTitles;
function percentComplete(course, completed_lessons) {
    var totalDuration = course.lessons.reduce(function (p, l) { return p + l.duration; }, 0);
    var completedDuration = course.lessons.reduce(function (p, l) {
        return p + (isLessonComplete(l, completed_lessons) ? l.duration : 0);
    }, 0);
    return completedDuration / totalDuration;
}
exports.percentComplete = percentComplete;
function isLessonComplete(lesson, completed_lessons) {
    return (0, lodash_1.some)(completed_lessons, { slug: lesson.slug });
}
exports.isLessonComplete = isLessonComplete;
function hmsToSeconds(str) {
    var p = str.split(':'), s = 0, m = 1;
    while (p.length > 0) {
        s += m * parseInt(p.pop(), 10);
        m *= 60;
    }
    return s;
}
exports.hmsToSeconds = hmsToSeconds;
